@if(patient){
<div tuiCardLarge tuiSurface="elevated">
    <div class="row">
        <div class="col col-12">
            <h2>Traitement</h2>
        </div>
    </div>

    @if (activite != null || !codeActiviteService.AEROSOLS.includes(activite!)) {
    <div class="row">
        <div class="col col-12">
            @if (servoVentilation) {
            <app-traitement-ppc-servo-ventilation-card [patient]="patient" />
            }
            @else if(codeActiviteService.PPC.includes(activite!) || activite == 'O2PPC'){
            <app-traitement-ppc-card [patient]="patient" [activite]="activite" />
            } @else if (codeActiviteService.VENTILATION.includes(activite!) || activite == 'O2VNI') {
            <app-traitement-vni-card [patient]="patient" [activite]="activite" />
            } @else if (codeActiviteService.O2.includes(activite!)) {
            <app-traitement-o2-card [patient]="patient" />
            } @else if (codeActiviteService.AVF.includes(activite!)) {
            <app-traitement-avf-card [patient]="patient" />
            }
        </div>
    </div>
    }

</div>
}@else{

<div tuiCardLarge tuiSurface="elevated">
    <div class="row">
        <div class="col col-12">
            <h2>Traitement</h2>
        </div>
    </div>

    <div class="row">
        <div class="col col-12">
            <app-traitement-ppc-card />
        </div>
    </div>

</div>
}